import React from "react";
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import green from '@material-ui/core/colors/green';
import red from '@material-ui/core/colors/red';
import { Paper } from "@material-ui/core";
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';

const styles = theme => ({
    root: {
        flexGrow: 1,
        overflow: 'hidden',
    },
    paper: {
        padding: theme.spacing.unit,
        margin: theme.spacing.unit,
    },
    card: {
      minWidth: 275,
    },
    bullet: {
      display: 'inline-block',
      margin: '0 2px',
      transform: 'scale(0.8)',
    },
    title: {
      fontSize: 18,
      fontWeight: 'bold',
    },
    pos: {
      marginBottom: 12,
    },
    group: {
      margin: `${theme.spacing.unit}px 0`,
    },
    formControl: {
        margin: theme.spacing.unit,
    },
    formLabel: {
        textAlign: 'left',
    },
    formInput: {
        padding: 0,
    },
    greenradio: {
        color: green[600],
        '&$checked': {
            color: green[500],
        },
    },
    redradio: {
        color: red[600],
        '&$checked': {
            color: red[500],
        },
    },
    checked: {},
    divider: {
        margin: 16,
    }
});

class ClaimENStep5 extends React.Component {
    state = {
        fp17data: this.props.fp17data,
        pdata: this.props.pdata,
    };

    handleChange = name => event => {
        //this.setState({ [name]: event.target.value });
        let datatmp = this.state.fp17data;
        datatmp[name] = event.target.value;
        this.setState({fp17data: datatmp});        
    };

    handleCheckChange = name => event => {
        //this.setState({ [name]: event.target.value });
        let value = undefined;

        if (event.target.checked === true)
            value = event.target.value;
        else
            value = undefined;

        let datatmp = this.state.fp17data;
        datatmp[name] = value;
        this.setState({fp17data: datatmp}); 
    };

    render() {
        const { classes } = this.props;

        return (
        <div className={classes.root}>
            <Paper className={classes.paper}>
                <Typography className={classes.title} color="textSecondary" gutterBottom>
                Ethnic Origin
                </Typography>
                <Grid container spacing={1}>
                  <FormControl className={classes.formControl} fullWidth={true}>
                    <Select
                      value={this.state.fp17data.ethorg}
                      onChange={this.handleChange('ethorg')}
                      inputProps={{
                        name: 'ethorg',
                        id: 'claim-ethorg',
                      }}
                    >
                        <MenuItem value="99">Patient Declined</MenuItem>
                        <MenuItem value="01">White British</MenuItem>
                        <MenuItem value="02">White Irish</MenuItem>
                        <MenuItem value="03">White Other</MenuItem>
                        <MenuItem value="04">White and Black Caribbean</MenuItem>
                        <MenuItem value="05">White and Black African</MenuItem>
                        <MenuItem value="06">White and Asian</MenuItem>
                        <MenuItem value="07">Other Mixed Background</MenuItem>
                        <MenuItem value="08">Asian or Asian British Indian</MenuItem>
                        <MenuItem value="09">Asian or Asian British Pakistani</MenuItem>
                        <MenuItem value="10">Asian or Asian British Bangladeshi</MenuItem>
                        <MenuItem value="11">Other Asian Bbackground</MenuItem>
                        <MenuItem value="12">Black or Black British Caribbean</MenuItem>
                        <MenuItem value="13">Black or Black British African</MenuItem>
                        <MenuItem value="14">Other Black Background</MenuItem>
                        <MenuItem value="15">Chinese</MenuItem>
                        <MenuItem value="16">Any Other Ethnic Group</MenuItem>
                    </Select>                    
                  </FormControl>                   
                </Grid>
            </Paper>
            <Paper className={classes.paper}>
                <Typography className={classes.title} color="textSecondary" gutterBottom>
                Contact Consent
                </Typography>
                <Grid container spacing={3}>
                    { this.state.pdata.hasemail === true ?
                    <Grid item xs={12} sm={4}>
                        <FormControl className={classes.formControl} fullWidth={true}>
                            <FormControlLabel
                                value="y"
                                id="nhs_emailconsent"
                                label="Send Email address"
                                control={<Checkbox checked={this.state.fp17data.nhs_emailconsent === 'y'}/>}
                                onChange={this.handleCheckChange('nhs_emailconsent')}
                            />
                        </FormControl>  
                    </Grid> : null }
                    { this.state.pdata.hasmobile === true ?
                    <Grid item xs={12} sm={4}>
                    <FormControl className={classes.formControl} fullWidth={true}>
                            <FormControlLabel
                                value="y"
                                id="nhs_mobileconsent"
                                label="Send mobile number"
                                control={<Checkbox checked={this.state.fp17data.nhs_mobileconsent === 'y'}/>}
                                onChange={this.handleCheckChange('nhs_mobileconsent')}
                            />
                        </FormControl>  
                    </Grid> : null }            
                </Grid>
            </Paper>                                   
                    
        </div>
        );
    }
}

ClaimENStep5.propTypes = {
    classes: PropTypes.object.isRequired,
  };
  
  export default withStyles(styles)(ClaimENStep5);